import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Header from 'components/ui/general/Header';
import LoadingCard from 'components/loading/LoadingCard';
import ProductLocalisationEditForm from './ProductLocalisationEditForm';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import ShowButton from 'components/button/ShowButton';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { Card, CardText } from 'material-ui';
import { connect } from 'react-redux';
import { fetchProductLocalisation } from 'store/actions/product-localisation/fetchProductLocalisation';
import { updateProductLocalisation } from 'store/actions/product-localisation/updateProductLocalisation';
import { fetchProduct } from 'store/actions/products/fetchProducts';

class ProductLocalisationEditContainer extends React.Component {
    formatFormResults = (values) => {
        const {
            system,
        } = this.context.config.language;

        let baseValues = {
            ...values.localisation[system],
        };

        const localisationValues = utils.filterEmptyValues(values.localisation);

        return {
            base: baseValues,
            localisation: localisationValues,
        };
    }

    handleSubmitForm = (values) => {
        const {
            dispatchForm,
            history,
            id,
        } = this.props;

        if (utils.isEmpty(values)) {
            return null;
        }

        const convertedValues = this.formatFormResults(values);

        return new Promise((resolve, reject) => {
            return dispatchForm({
                onError: () => {
                    reject();
                },
                onSuccess: () => {
                    resolve(history.push(`/products/${ id }/show`));
                },
                formValues: convertedValues,
                id: id,
            });
        });
    }

    render() {
        const {
            data,
            id,
            product,
            resourceFetchLoading,
            resourceFetchFailed,
            translate,
        } = this.props;

        if (resourceFetchLoading || utils.isEmpty(product)) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: product.title,
                link: `/products/${ id }/show`,
            },
            {
                label: translate('resources.products.actions.localisation'),
            },
            {
                label: translate('actions.edit'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('resources.products.actions.localisation', { title: data.name }) } />

                    <Actions>
                        <ShowButton url={ `/products/${ id }/show` } />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        <ProductLocalisationEditForm
                            form='product_localisation_edit'
                            handleSubmitForm={ this.handleSubmitForm }
                            localisation={ data }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

ProductLocalisationEditContainer.contextTypes = {
    config: PropTypes.object,
};

ProductLocalisationEditContainer.propTypes = {
    data: PropTypes.object,
    dispatchForm: PropTypes.func.isRequired,
    history: PropTypes.object,
    id: PropTypes.string,
    product: PropTypes.shape({
        title: PropTypes.string,
    }),
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchForm: (values) => {
            dispatch(updateProductLocalisation(values));
        },
    };
};

const enhance = compose(
    translate,
    connect(
        (state, props) => {
            return {
                product: state.products.data[props.id],
            };
        },
        mapDispatchToProps
    ),
    fetchResourceById({
        action: fetchProduct,
        resource: 'products',
    }),
    fetchResourceById({
        action: fetchProductLocalisation,
        resource: 'productLocalisation',
    }),
);

export default enhance(ProductLocalisationEditContainer);



// WEBPACK FOOTER //
// ./src/pages/products/productLocalisation/edit/ProductLocalisationEditContainer.js